module.exports = __webpack_public_path__ + "img/website.4afd93f2.png";